<template>
 <div class="breadCrumb">
      <div><h3>Test Fonction</h3></div>
      <div>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">Configurations</li>
            <li class="breadcrumb-item active" aria-current="page">Test</li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="row">
        <div class="col-md-2">
            <div class="form-group">
            <input type="text" class="search-form" v-model="searchQuery">
             </div>
        </div>
        <div class="col-md-2">
            {{ userNumber }}
        </div>
    </div>
    
    <div>
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>#</th><th>Nom</th><th>Prénom</th><th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in filteredUsers" :key="index" >
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.nom }}</td>
                    <td>{{ item.prenom }}</td>
                    <td>
                    </td>
                </tr>
            </tbody>

        </table>
    </div>
</template>
<script>
export default {
    data() {
        return {
            searchQuery: '',
            users: []
        }
    },
    computed: {

        userNumber() {
            return this.filteredUsers.length;
        },
        filteredUsers() {
            if(!this.searchQuery) {    
               return this.users.sort((a, b) => a.nom.localeCompare(b.nom));
            }
            return this.users
    .filter(user => {
      return (
        user.nom.toLowerCase().includes(this.searchQuery.toLowerCase()) || 
        user.prenom.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    })
    .sort((a, b) => a.nom.localeCompare(b.nom)); // Correction ici
        }
    },
    created() {
        this.users = [
                {id: 1, nom: 'Diallo', prenom: 'Amadou'},
                {id: 2, nom: 'Sangaré', prenom: 'Drissa'},
                {id: 3, nom: 'Traoré', prenom: 'Seydou'},
                {id: 4, nom: 'Koita', prenom: 'Drissa'},
                {id: 5, nom: 'Keita', prenom: 'Drissa'},
                {id: 6, nom: 'Diallo', prenom: 'Moussa'}
        ]
    }
}
</script>

<style>
</style>